import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=53cc734f&scoped=true&"
import script from "./BannerComponent.vue?vue&type=script&lang=js&"
export * from "./BannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./BannerComponent.vue?vue&type=style&index=0&id=53cc734f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc734f",
  null
  
)

export default component.exports